module.exports = __webpack_public_path__ + "static/img/8502_phase_function_Paper_PointsHejduk_Prediction.15895b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8502_phase_function_Paper_PointsHejduk_Prediction.png
// module id = vLl1
// module chunks = 0